import { RefreshCw } from 'lucide-react';

export function ForceUpdateGate({ onRefresh }: { onRefresh: () => void }) {
  return (
    <div className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-plum/10 flex items-center justify-center mb-6">
        <RefreshCw size={28} className="text-plum" />
      </div>
      <h1 className="font-display text-h1 text-midnight mb-2">Update Required</h1>
      <p className="text-[15px] text-slate leading-relaxed max-w-sm mb-8">
        This version is no longer supported. Please refresh to get the latest version and continue using IOMI.
      </p>
      <button
        type="button"
        onClick={onRefresh}
        className="h-12 px-8 rounded-xl bg-plum text-white text-small font-semibold
                   hover:bg-rose active:opacity-80 transition-colors"
      >
        Refresh Now
      </button>
    </div>
  );
}
